import { createFileRoute } from "@tanstack/react-router";
import { PartnerDetail } from "@/features/masters/components/partner-detail";

export const Route = createFileRoute("/_app/masters/vendors/$id")({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <PartnerDetail masterKey="vendors" id={Number(id)} />;
}
